//Development
//const apiUrl = 'http://localhost:5757';

// Production
const apiUrl = 'http://dashboard.freshjuiceglobal.com' || 'http://localhost:5757';

export default {
  api: {
    bomgarUsers: `${apiUrl}/data/bomgarusers.json`,
    eqaData: `${apiUrl}/data/EQAData.json`,
    badRecordings: `${apiUrl}/data/badRecordings.json`,
    s3Data: `${apiUrl}/data/S3Data.json`,
    siteData: `${apiUrl}/data/siteData.json`,
    allRecordings: `${apiUrl}/data/allRecordings.json`
  },
};